import { Controller } from "@hotwired/stimulus"

export default class TiltController extends Controller {
  static values = {
    maxRotation: { type: Number, default: 15 },
    scale: { type: Number, default: 1.05 }
  }

  connect () {
    this.boundingRect = null
  }

  mouseenter (event) {
    this.boundingRect = event.currentTarget.getBoundingClientRect()
  }

  mousemove (event) {
    if (!this.boundingRect) return

    const el = event.currentTarget
    const x = event.clientX - this.boundingRect.left
    const y = event.clientY - this.boundingRect.top
    const xPercent = x / this.boundingRect.width
    const yPercent = y / this.boundingRect.height
    const xRotation = (yPercent - 0.5) * this.maxRotationValue * -2
    const yRotation = (xPercent - 0.5) * this.maxRotationValue * 2

    el.style.setProperty("--x-rotation", `${xRotation}deg`)
    el.style.setProperty("--y-rotation", `${yRotation}deg`)
    el.style.setProperty("--x", `${xPercent * 100}%`)
    el.style.setProperty("--y", `${yPercent * 100}%`)
  }

  mouseleave () {
    this.boundingRect = null
    const el = this.element
    el.style.removeProperty("--x-rotation")
    el.style.removeProperty("--y-rotation")
    el.style.removeProperty("--x")
    el.style.removeProperty("--y")
  }
}